export const EXCHANGE_ACCOUNT_POPULATE_FULL = [
    "exchange.servers",
    "user",
    "bot_configs",
];
export const EXCHANGE_ACCOUNT_POPULATE_DEFAULT = [
    "exchange.servers",
];
export const EXCHANGE_ACCOUNT_POPULATE_LIST = [
    "exchange",
    "user",
];
export const EXCHANGE_ACCOUNT_POPULATE_MINIMAL = [
    "exchange",
];
export const EXCHANGE_ACCOUNT_POPULATE_MOBILE = [
    "bot_configs",
];
export const EXCHANGE_ACCOUNT_POPULATE = {
    FULL: EXCHANGE_ACCOUNT_POPULATE_FULL,
    DEFAULT: EXCHANGE_ACCOUNT_POPULATE_DEFAULT,
    LIST: EXCHANGE_ACCOUNT_POPULATE_LIST,
    MINIMAL: EXCHANGE_ACCOUNT_POPULATE_MINIMAL,
    MOBILE: EXCHANGE_ACCOUNT_POPULATE_MOBILE,
};
export const EXCHANGE_POPULATE_FULL = ["trading_assets", "servers"];
export const EXCHANGE_POPULATE_DEFAULT = [
    "trading_assets",
    "servers",
];
export const EXCHANGE_POPULATE_LIST = ["servers"];
export const EXCHANGE_POPULATE = {
    FULL: EXCHANGE_POPULATE_FULL,
    DEFAULT: EXCHANGE_POPULATE_DEFAULT,
    LIST: EXCHANGE_POPULATE_LIST,
};
